module.exports = __webpack_public_path__ + "static/media/church.4005c8c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/church.jpg
// module id = 710
// module chunks = 0